import { crops } from '@terraframing-suite/rx-config';
import { MenuItem, TextField } from '@mui/material';

export function CropSelector(props) {
  return (
    <TextField
      size="small"
      select
      InputLabelProps={{ shrink: true }}
      {...props}
    >
      {[<MenuItem value="">&nbsp;</MenuItem>].concat(
        crops.map(({ label, id }) => (
          <MenuItem key={id} value={id}>
            {label}
          </MenuItem>
        )),
      )}
    </TextField>
  );
}
